export enum TempWaitlistReasons {
	IDENTITY_UNVERIFIABLE = 'IDENTITY_UNVERIFIABLE',
	LOW_QUALITY_APPLICATION = 'LOW_QUALITY_APPLICATION',
	CAREER_FIELDS_UPDATE = 'CAREER_FIELDS_UPDATE',
	LOW_QUALITY_CANDIDATE = 'LOW_QUALITY_CANDIDATE',
	SUSPICIOUS_APPLICATION = 'SUSPICIOUS_APPLICATION',
	NO_INSTAGRAM = 'NO_INSTAGRAM',
	OTHER = 'OTHER',
	BROKEN_INSTAGRAM_LINK = 'BROKEN_INSTAGRAM_LINK',
	VERIFICATION_PHOTO_MISMATCH = 'VERIFICATION_PHOTO_MISMATCH',
}

export enum PermWaitlistReasons {
	EXTREMELY_LOW_QUALITY_CANDIDATE = 'EXTREMELY_LOW_QUALITY_CANDIDATE',
	EXTREMELY_LOW_QUALITY_APPLICATION = 'EXTREMELY_LOW_QUALITY_APPLICATION',
	CATFISH_APPLICATION = 'CATFISH_APPLICATION',
	INAPPROPRIATE_APPLICATION = 'INAPPROPRIATE_APPLICATION',
	OTHER = 'OTHER',
}

export enum BlacklistReasons {
	OFFENSIVE_APPLICATON = 'OFFENSIVE_APPLICATON',
	SUSPENDED_ACCOUNT_REAPPLIED = 'SUSPENDED_ACCOUNT_REAPPLIED',
	OTHER = 'OTHER',
}

export const categoryReasonToHumanReadableMap = {
	[TempWaitlistReasons.IDENTITY_UNVERIFIABLE]: 'Requested Application Edits (Application photo)',
	[TempWaitlistReasons.LOW_QUALITY_CANDIDATE]: 'Maybe later',
	[TempWaitlistReasons.LOW_QUALITY_APPLICATION]: 'Requested Application Edits (About you)',
	[TempWaitlistReasons.CAREER_FIELDS_UPDATE]: 'Requested Application Edits (Career & education)',
	[TempWaitlistReasons.SUSPICIOUS_APPLICATION]: 'Seems sus…',
	[TempWaitlistReasons.NO_INSTAGRAM]: 'Requested ID (No Instagram)',
	[TempWaitlistReasons.BROKEN_INSTAGRAM_LINK]: 'Requested Application Edits (Instagram handle)',
	[TempWaitlistReasons.VERIFICATION_PHOTO_MISMATCH]: 'Requested Application Edits (Live photo)',
	[TempWaitlistReasons.OTHER]: 'Something else',
	[PermWaitlistReasons.EXTREMELY_LOW_QUALITY_CANDIDATE]: 'Not Lox Club Material',
	[PermWaitlistReasons.EXTREMELY_LOW_QUALITY_APPLICATION]: 'Terrible application - P',
	[PermWaitlistReasons.CATFISH_APPLICATION]: "Where's Nev Shulman!?",
	[PermWaitlistReasons.INAPPROPRIATE_APPLICATION]: 'Inappropriate',
	[BlacklistReasons.OFFENSIVE_APPLICATON]: 'Extremely inappropriate',
	[BlacklistReasons.SUSPENDED_ACCOUNT_REAPPLIED]: 'Suspended/blacklisted account reapplied',
};

export enum ClubIdentifier {
	LOX_CLUB = 'LOX_CLUB',
	JADE_CLUB = 'JADE_CLUB',
	AMARA_CLUB = 'AMARA_CLUB',
}

export const ClubIdentifierToHumanReadable = {
	[ClubIdentifier.LOX_CLUB]: 'Lox Club',
	[ClubIdentifier.JADE_CLUB]: 'Jade Club',
	[ClubIdentifier.AMARA_CLUB]: 'Amara Club',
	undefined: 'Lox Club',
};
